// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m3qZ","left":"styles_left__3wTqR"};